// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IG3t","right":"styles_right__2Q9TO"};